import React from 'react';
import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const Header = styled.h1`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 24px;
  font-weight: 500;
  margin: 0;
  padding: 0;
`;

export const LockedText = styled.p`
  color: ${({ theme }) => theme.palette.text.disabled};
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  padding: 0;
  margin-left: 4px;
`;

export const MainContainer = styled.div`
  display: flex;
  padding: 70px 150px;
  gap: 10px;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.common.white};
  height: calc(100% - 54px);
  justify-content: center;
`;

export const KeyFeatures = styled.h3`
  color: ${({ theme }) => theme.palette.primary.dark};
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  line-height: 55px;
  text-transform: capitalize;
  margin: 0;
`;

export const Info = styled.p`
  color: ${({ theme }) => theme.palette.primary.dark};
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 30px;
  margin: 0;
`;
